import { useTranslation } from 'react-i18next';
import React from 'react';

export default function ExperienceNotAvailableDueToCurrencyMismatch() {
  const { t } = useTranslation('experiences');

  return (
    <div className="w-full bg-red-100 px-4 py-2 rounded">
      <div className="text-sm text-red-400">{t('currencyMismatch')}</div>
    </div>
  );
}
